package com.shadowings.gero.data.repository

import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.ab01
import gero.composeapp.generated.resources.ab02
import gero.composeapp.generated.resources.ab03
import gero.composeapp.generated.resources.ab05
import gero.composeapp.generated.resources.ab06
import gero.composeapp.generated.resources.ab08
import gero.composeapp.generated.resources.ab14
import gero.composeapp.generated.resources.ab15
import gero.composeapp.generated.resources.ab18
import gero.composeapp.generated.resources.ab20
import gero.composeapp.generated.resources.ab22
import gero.composeapp.generated.resources.ab23
import gero.composeapp.generated.resources.ab24
import gero.composeapp.generated.resources.ab27
import gero.composeapp.generated.resources.ab29
import gero.composeapp.generated.resources.amenamhat
import gero.composeapp.generated.resources.cielo
import gero.composeapp.generated.resources.inpu
import gero.composeapp.generated.resources.iten
import gero.composeapp.generated.resources.mentuhotep
import gero.composeapp.generated.resources.miit
import gero.composeapp.generated.resources.scribe
import gero.composeapp.generated.resources.acqua
import gero.composeapp.generated.resources.re_basso
import gero.composeapp.generated.resources.neferhotep
import gero.composeapp.generated.resources.ptah
import gero.composeapp.generated.resources.ri00182
import gero.composeapp.generated.resources.ri00200
import gero.composeapp.generated.resources.tutankhamon
import gero.composeapp.generated.resources.tutankhamon2
import org.jetbrains.compose.resources.DrawableResource

// Maps the drawable code stored in ImageKeyboardContent / WrongAnswerRecord to its resource.
object InscriptionImages {

    fun resFromCode(code: String): DrawableResource? = when (code) {
        "ab01" -> Res.drawable.ab01
        "ab02" -> Res.drawable.ab02
        "ab03" -> Res.drawable.ab03
        "ab05" -> Res.drawable.ab05
        "ab06" -> Res.drawable.ab06
        "ab08" -> Res.drawable.ab08
        "ab14" -> Res.drawable.ab14
        "ab15" -> Res.drawable.ab15
        "ab18" -> Res.drawable.ab18
        "ab20" -> Res.drawable.ab20
        "ab22" -> Res.drawable.ab22
        "ab23" -> Res.drawable.ab23
        "ab24" -> Res.drawable.ab24
        "ab27" -> Res.drawable.ab27
        "ab29" -> Res.drawable.ab29
        "amenamhat" -> Res.drawable.amenamhat
        "mentuhotep" -> Res.drawable.mentuhotep
        "neferhotep" -> Res.drawable.neferhotep
        "tutankhamon" -> Res.drawable.tutankhamon
        "tutankhamon2" -> Res.drawable.tutankhamon2
        "inpu" -> Res.drawable.inpu
        "iten" -> Res.drawable.iten
        "ptah" -> Res.drawable.ptah
        "miit" -> Res.drawable.miit
        "cielo" -> Res.drawable.cielo
        "scribe" -> Res.drawable.scribe
        "acqua" -> Res.drawable.acqua
        "re_basso" -> Res.drawable.re_basso
        "ri00182" -> Res.drawable.ri00182
        "ri00200" -> Res.drawable.ri00200
        else -> null
    }
}
